import { useMutation } from '@tanstack/react-query';
import { getOrCreateRecipeTemplate } from '../../services/automations';
import { invalidateEmailTemplates } from '../../services/marketing';
import { AutomationRecipe } from '../../types/marketing/automations';

interface Options {
  onSuccess?: (templateId: number) => void;
  onError?: (message: string) => void;
}

function useRecipeTemplate({ onSuccess, onError }: Options = {}) {
  return useMutation({
    mutationFn: async ({
      marketingBusinessId,
      recipe,
    }: {
      marketingBusinessId: string;
      recipe: AutomationRecipe;
    }) =>
      getOrCreateRecipeTemplate({ marketingBusinessId, recipeId: recipe.id }),
    onSuccess: async result => {
      await invalidateEmailTemplates();
      onSuccess?.(result.template.id);
    },
    onError: error => onError?.(error.message),
  });
}

export default useRecipeTemplate;
